export default "__VITE_ASSET__PSYtT4wd__"